<mat-dialog-content>
  <mat-dialog-actions align="end">
    <img mat-dialog-close src="../../../assets/images/forgot-password-close-icon.svg">
  </mat-dialog-actions>
  <div class="icon-container">
    <img src="../../../assets/images/account-locked-icon.svg">
  </div>
  <div class="login-container">
    <div class="title">
      <h2>Account is locked</h2>
    </div>
    <div>
      <p class="forgot-info">Your account has been temporaily locked due to entering wrong password.<br>Try after 24
        hours</p>
    </div>
  </div>
</mat-dialog-content>